import React from "react";
import { Modal } from "scmp-sdk/components/modal";

import { Container } from "./styles";

export type Props = {
  children: React.ReactNode;
  isShow: boolean;
  onClose: () => void;
};

export const Popup: React.FunctionComponent<Props> = ({ children, isShow, onClose }) => (
  <Modal onClose={onClose} open={isShow}>
    <Container>{children}</Container>
  </Modal>
);

Popup.displayName = "Popup";
